import(/* webpackMode: "eager" */ "/app/src/app/(frontend)/flight/page.tsx");
